import React from "react";
import {withFormik} from "formik";
import PropTypes from "prop-types";
import "../../styles/vendor/react-checkbox-tree.css";
import {Link} from "react-router-dom";
import BasicCheckbox from "./fields/BasicCheckbox";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import {getCompanies} from "../../services/api/companies";
import {Trans, withTranslation} from "react-i18next";
import {flowRight} from "lodash";
import SimpleCheckbox from "./fields/SimpleCheckbox";
import BasicSelect from "./fields/BasicSelect";
import {getParkings} from "../../services/api/parkings";
import {getEventProfiles} from "../../services/api/profiles";
import {getDepartments} from "../../services/api/departments";
import CustomTypeahead from "./fields/CustomTypeahead";
import {baseValue} from "../../libs/utils";
import ReportDownloadButton from "../admin/reporting/exports/ReportDownloadButton";
import ShowAdminsButton from "../shared/crewMembers/ShowAdminsButton";

class InnerForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            companies: [],
            defaultCompany: [],
            departments: [],
            defaultDepartments: [],
            parkings: [],
            defaultParkings: [],
            profiles: [],
            defaultProfiles: [],
            materialCategories: []
        };

        this._handleCompanySearch = this._handleCompanySearch.bind(this);
        this._handleProfilesSearch = this._handleProfilesSearch.bind(this);
        this._handleParkingSearch = this._handleParkingSearch.bind(this);
        this._handleDepartmentsSearch = this._handleDepartmentsSearch.bind(this);

        this._handleNewCompany = this._handleNewCompany.bind(this);
        this._handleNewDepartment = this._handleNewDepartment.bind(this);
        this._handleNewParking = this._handleNewParking.bind(this);
        this._handleNewProfile = this._handleNewProfile.bind(this);
    }

    static propTypes = {
        handleSubmit: PropTypes.func,
        isSubmitting: PropTypes.bool,
        submitting: PropTypes.bool,
        setValues: PropTypes.func,
        cateringOptions: PropTypes.array,
        setFieldValue: PropTypes.func,
        event: PropTypes.object,
        registration: PropTypes.object,
        t: PropTypes.func,
        crewMaterials: PropTypes.array,
        materialCategories: PropTypes.array,
        values: PropTypes.object
    };

    UNSAFE_componentWillMount() {
        const registration = this.props.registration;
        if (registration) {
            this.setState({
                defaultCompany: [registration.company],
                defaultProfiles: registration.registrationProfiles.map(
                    profile => profile.profile
                ),
                defaultDepartments: registration.departments,
                defaultParkings: registration.parkings
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const currentProps = this.props;
        const {registration} = nextProps;

        if (currentProps.registration !== registration) {
            currentProps.resetForm();
        }
    }

    _handleCompanySearch(value) {
        getCompanies({
            "filter[name]": value,
            "filter[exclude_registered_for_event_id]": this.props.event.id
        }).then(response => {
            this.setState({
                companies: response.data
            });
        });
    }

    _handleParkingSearch(value) {
        getParkings(this.props.event.id, {
            "filter[name]": value
        }).then(response => {
            this.setState({
                parkings: response.data
            });
        });
    }

    _handleProfilesSearch(value) {
        getEventProfiles(this.props.event.id, {
            "filter[name]": value
        }).then(response => {
            this.setState({
                profiles: response.data
            });
        });
    }

    _handleDepartmentsSearch(value) {
        getDepartments({
            "filter[name]": value
        }).then(response => {
            this.setState({
                departments: response.data
            });
        });
    }

    _handleNewCompany(values) {
        if (values.length > 0) {
            this.props.setFieldValue("companyId", values[0].id);
            this.setState({
                defaultCompany: [values[0]]
            });
        }
    }

    _handleNewParking(values) {
        this.props.setFieldValue(
            "parkings",
            values.map(value => value.id)
        );
    }

    _handleNewDepartment(values) {
        this.props.setFieldValue(
            "departments",
            values.map(value => value.id)
        );
    }

    _handleNewProfile(values) {
        this.props.setFieldValue(
            "profiles",
            values.map(value => value.id)
        );
    }

    render() {
        const props = this.props;
        const {
            t,
            crewMaterials,
            values,
            cateringOptions,
            materialCategories,
            registration
        } = this.props;

        return (
            <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
                <div className="row">
                    <div className="col-xl-6">
                        <div className="m-portlet m-portlet--full-height">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <span className="m-portlet__head-icon">
                                            <i className="flaticon-information"/>
                                        </span>
                                        <h3 className="m-portlet__head-text">
                                            <Trans>Registration Info</Trans>
                                        </h3>
                                    </div>
                                </div>
                            </div>

                            <div className="m-portlet__body">
                                <input type="hidden" name="id"/>

                                <CustomTypeahead
                                    name="companyId"
                                    label="Company"
                                    multiple={false}
                                    options={this.state.companies}
                                    selected={this.state.defaultCompany}
                                    placeholder={t("Choose a company") + "..."}
                                    labelKey="name"
                                    onSearch={this._handleCompanySearch}
                                    onChange={this._handleNewCompany}
                                    id="companyTypeahead"
                                    {...props}
                                />

                                <div className="form-group m-form__group">
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="sendVouchersToAdmin"
                                        label="Send Vouchers To Admin"
                                    />
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="sendCateringInvoice"
                                        label="Send Catering Invoice"
                                    />
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="excelImportsAllowed"
                                        label="Allow Excel import"
                                    />
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="frozen"
                                        label="Freeze Registration"
                                    />
                                </div>

                                <div className="form-group m-form__group">
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="materialRequestsAllowed"
                                        label="Allow Material Requests"
                                    />
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="transportRequestsAllowed"
                                        label="Allow Gatekeeping Requests"
                                    />
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="allDayTransportRequestsAllowed"
                                        label="Allow All Day Gatekeeping Requests"
                                    />
                                    <BasicCheckbox
                                        noFormGroup
                                        {...props}
                                        name="frequentPassageRequestsAllowed"
                                        label="Allow Frequent Passage Requests"
                                    />
                                </div>

                                {crewMaterials.length > 0 && (
                                    <div className="m-form__group form-group">
                                        <label htmlFor="">Crew Materials</label>
                                        <div className="m-checkbox-list">
                                            {crewMaterials.map(material => (
                                                <div
                                                    key={material.id}
                                                    className="row align-items-center"
                                                >
                                                    <div className="col-md-3">
                                                        <SimpleCheckbox
                                                            {...props}
                                                            name={"material_" + material.id}
                                                            label={material.name}
                                                            key={material.id}
                                                        />
                                                    </div>
                                                    <div
                                                        className="col-md-9"
                                                        style={{
                                                            display: values["material_" + material.id]
                                                                ? "block"
                                                                : "none",
                                                            paddingTop: 5,
                                                            paddingBottom: 5
                                                        }}
                                                    >
                                                        {material.crewMemberMaterialTemplates.length >
                                                            0 && (
                                                                <BasicSelect
                                                                    {...props}
                                                                    name={"material_" + material.id + "_template"}
                                                                    placeholder="Choose a template"
                                                                    noFormGroup={true}
                                                                    options={material.crewMemberMaterialTemplates.map(
                                                                        template => {
                                                                            return {
                                                                                value: template.id,
                                                                                title: `${template.name}`
                                                                            };
                                                                        }
                                                                    )}
                                                                />
                                                            )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <div className="form-group m-form__group">
                                    <label htmlFor="">Allowed Catering Options</label>
                                    {cateringOptions.map(option => (
                                        <BasicCheckbox
                                            noFormGroup
                                            {...props}
                                            key={`cateringoptions_${option.id}`}
                                            name={`cateringoptions_${option.id}`}
                                            label={option.name}
                                        />
                                    ))}
                                </div>

                                {materialCategories.length > 0 && (
                                    <div className="form-group m-form__group">
                                        <label htmlFor="">Allowed Material Categories</label>
                                        {materialCategories.map(option => (
                                            <BasicCheckbox
                                                noFormGroup
                                                {...props}
                                                key={`materialcategories_${option.id}`}
                                                name={`materialcategories_${option.id}`}
                                                label={option.name}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6">
                        {registration && (
                            <div className="m-portlet">
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title">
                                            <span className="m-portlet__head-icon">
                                                <i className="flaticon-computer"/>
                                            </span>
                                            <h3 className="m-portlet__head-text">
                                                <Trans>Info</Trans>
                                            </h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="m-portlet__body">
                                    <div className="form-group m-form__group">
                                        <ReportDownloadButton
                                            report={{
                                                downloadUrl: `/registrations/${registration.id}/crew-member-documents`,
                                                name: "Crew Documents " + registration.company.name,
                                                extension: "zip"
                                            }}
                                            inline
                                        />

                                        <ShowAdminsButton companyId={registration.company.id}/>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="m-portlet">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <span className="m-portlet__head-icon">
                                            <i className="flaticon-computer"/>
                                        </span>
                                        <h3 className="m-portlet__head-text">
                                            <Trans>Departments</Trans>
                                        </h3>
                                    </div>
                                </div>
                            </div>

                            <div className="m-portlet__body">
                                <div className="form-group m-form__group">
                                    <AsyncTypeahead
                                        multiple={true}
                                        options={this.state.departments}
                                        defaultSelected={this.state.defaultDepartments}
                                        isLoading={false}
                                        placeholder={t("Choose departments") + "..."}
                                        minLength={2}
                                        labelKey="name"
                                        onSearch={this._handleDepartmentsSearch}
                                        onChange={this._handleNewDepartment}
                                        id="departementTypeahead"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="m-portlet">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <span className="m-portlet__head-icon">
                                            <i className="flaticon-map-location"/>
                                        </span>
                                        <h3 className="m-portlet__head-text">
                                            <Trans>Parkings</Trans>{" "}
                                            <small>
                                                (<Trans>First one will be default</Trans>)
                                            </small>
                                        </h3>
                                    </div>
                                </div>
                            </div>

                            <div className="m-portlet__body">
                                <div className="form-group m-form__group">
                                    <AsyncTypeahead
                                        multiple={true}
                                        options={this.state.parkings}
                                        defaultSelected={this.state.defaultParkings}
                                        isLoading={false}
                                        placeholder={t("Choose a parking") + "..."}
                                        minLength={2}
                                        labelKey="name"
                                        onSearch={this._handleParkingSearch}
                                        onChange={this._handleNewParking}
                                        id="parkingsTypeahead"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="m-portlet">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <span className="m-portlet__head-icon">
                                            <i className="flaticon-user"/>
                                        </span>
                                        <h3 className="m-portlet__head-text">
                                            <Trans>Profiles</Trans>
                                        </h3>
                                    </div>
                                </div>
                            </div>

                            <div className="m-portlet__body">
                                <div className="form-group m-form__group">
                                    <AsyncTypeahead
                                        multiple={true}
                                        options={this.state.profiles}
                                        defaultSelected={this.state.defaultProfiles}
                                        isLoading={false}
                                        placeholder={t("Choose profiles") + "..."}
                                        minLength={2}
                                        labelKey="name"
                                        onSearch={this._handleProfilesSearch}
                                        onChange={this._handleNewProfile}
                                        id="profilesTypeahead"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="m-portlet">
                            <div className="m-portlet__foot">
                                <div className="row align-items-center">
                                    <div className="col-lg-12 m--align-right">
                                        <button
                                            className={
                                                "btn m-btn btn-primary" +
                                                (props.isSubmitting
                                                    ? " m-btn--custom m-loader m-loader--light m-loader--left"
                                                    : "")
                                            }
                                            disabled={props.isSubmitting}
                                        >
                                            <Trans>
                                                {this.props.registration ? "Update" : "Create and View"}
                                            </Trans>
                                        </button>
                                        {!this.props.registration && [
                                            <button
                                                key="1"
                                                className={
                                                    "m--margin-left-10 btn m-btn btn-secondary" +
                                                    (props.isSubmitting
                                                        ? " m-btn--custom m-loader m-loader--light m-loader--left"
                                                        : "")
                                                }
                                                disabled={props.isSubmitting}
                                                onClick={() =>
                                                    this.props.setFieldValue("redirect", false)
                                                }
                                            >
                                                Create
                                            </button>,

                                            <span key="2" className="m--margin-left-10">
                                                <Trans>or</Trans>{" "}
                                                <Link
                                                    to="/admin/registrations"
                                                    className="m-link m--font-bold"
                                                >
                                                    <Trans>Cancel</Trans>
                                                </Link>
                                            </span>
                                        ]}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default flowRight(
    withTranslation(),
    withFormik({
        mapPropsToValues: props => {
            const registration = baseValue(props.registration, {});

            let values = {
                companyId: baseValue(registration.company, null),
                id: baseValue(registration.id, null),
                excelImportsAllowed: baseValue(registration.excelImportsAllowed, false),
                materialRequestsAllowed: baseValue(registration.materialRequestsAllowed, false),
                transportRequestsAllowed: baseValue(registration.transportRequestsAllowed, false),
                allDayTransportRequestsAllowed: baseValue(registration.allDayTransportRequestsAllowed, false),
                frequentPassageRequestsAllowed: baseValue(registration.frequentPassageRequestsAllowed, false),
                sendCateringInvoice: baseValue(registration.sendCateringInvoice, false),
                sendVouchersToAdmin: baseValue(registration.sendVouchersToAdmin, false),
                frozen: !!registration.frozenAt,
                parkings: registration.parkings
                    ? registration.parkings.map(parking => parking.id)
                    : [],
                profiles: registration.registrationProfiles
                    ? registration.registrationProfiles.map(
                        registrationProfile => registrationProfile.profileId
                    )
                    : [],
                departments: registration.departments
                    ? registration.departments.map(parking => parking.id)
                    : [],
                materialCategoryIds: registration.materialCategories
                    ? registration.materialCategories.map(cat => cat.id)
                    : [],
                redirect: true
            };

            const {crewMaterials, cateringOptions, materialCategories} = props;

            materialCategories.forEach(option => {
                values["materialcategories_" + option.id] = false;
            });

            if (registration.materialCategories) {
                registration.materialCategories.forEach(option => {
                    values["materialcategories_" + option.id] = true;
                });
            }

            if (crewMaterials) {
                crewMaterials.forEach(material => {
                    values["material_" + material.id] = false;
                    values["material_" + material.id + "_template"] = "";
                });
            }

            if (registration.crewMemberMaterialTemplates) {
                registration.crewMemberMaterialTemplates.forEach(template => {
                    values["material_" + template.crewMemberMaterialId] = true;
                    values["material_" + template.crewMemberMaterialId + "_template"] =
                        template.id;
                });
            }

            cateringOptions.forEach(option => {
                values["cateringoptions_" + option.id] = false;
            });

            if (registration.allowedCateringOptions) {
                registration.allowedCateringOptions.forEach(option => {
                    values["cateringoptions_" + option.id] = true;
                });
            }

            return values;
        },
        validate: (values, props) => {
            let errors = {};

            if (values.companyId === null || values.companyId === "") {
                errors.companyId = "required";
            }

            return errors;
        },

        handleSubmit: (values, {props, resetForm}) => {
            props.onSubmit(values);
        },
        validateOnBlur: false,
        validateOnChange: false
    })
)(InnerForm);
